import React from "react";
import styled from "styled-components";

const FooterSection = styled.footer`
  background: #0a0a0a;
  padding: 60px 0 30px;
  border-top: 1px solid rgba(255, 215, 0, 0.1);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
`;

const FooterColumn = styled.div``;

const FooterTitle = styled.h3`
  font-family: "Playfair Display", serif;
  font-size: 1.5rem;
  color: #ffd700;
  margin-bottom: 1.5rem;
`;

const FooterLinks = styled.ul`
  list-style: none;
`;

const FooterLink = styled.li`
  margin-bottom: 1rem;

  a {
    color: #b0b0b0;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #ffd700;
    }
  }
`;

const FooterBottom = styled.div`
  padding-top: 30px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
  color: #757575;
`;

const Footer = () => {
  return (
    <FooterSection>
      <Container>
        <FooterGrid>
          <FooterColumn>
            <FooterTitle>Ferman</FooterTitle>
            <p style={{ color: "#b0b0b0", lineHeight: 1.8 }}>
              Luxury language learning redefined. Master any language with
              AI-powered personal tutors.
            </p>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Quick Links</FooterTitle>
            <FooterLinks>
              <FooterLink>
                <a href="#services">Services</a>
              </FooterLink>
              <FooterLink>
                <a href="#features">Features</a>
              </FooterLink>
              <FooterLink>
                <a href="#testimonials">Testimonials</a>
              </FooterLink>
              <FooterLink>
                <a href="#pricing">Pricing</a>
              </FooterLink>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Contact</FooterTitle>
            <FooterLinks>
              <FooterLink>
                <a href="mailto:hello@ferman.ai">hello@ferman.ai</a>
              </FooterLink>
              <FooterLink>
                <a href="tel:+1234567890">+1 (234) 567-890</a>
              </FooterLink>
            </FooterLinks>
          </FooterColumn>
        </FooterGrid>

        <FooterBottom>
          <p>&copy; 2024 Ferman. All rights reserved.</p>
        </FooterBottom>
      </Container>
    </FooterSection>
  );
};

export default Footer;
